// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TBxL","name":"styles_name__1GkVc","phone":"styles_phone__23OAX"};